import type {
  Client,
  ClientsPlaces,
  Place,
  Project,
  RootState,
  RouterViewMode,
  Aggregations,
  Unit,
} from "@/types";
import { RouterViewModeType } from "@/types";
import type { RouterState } from "@/types/store";
import type { GetterTree } from "vuex";

export const getters: GetterTree<RouterState, RootState> = {
  getViewMode(state): RouterViewMode {
    return state.viewMode;
  },
  hasViewMode(state): boolean {
    return state.viewMode.type !== RouterViewModeType.NONE;
  },
  isNoneViewMode(state): boolean {
    return state.viewMode.type === RouterViewModeType.NONE;
  },
  isClientViewMode(state): boolean {
    return state.viewMode.type === RouterViewModeType.CLIENT;
  },
  isPlaceViewMode(state): boolean {
    return state.viewMode.type === RouterViewModeType.PLACE;
  },
  isProjectViewMode(state): boolean {
    return state.viewMode.type === RouterViewModeType.PROJECT;
  },
  getPlaces(state): Place[] {
    return state.places.data;
  },
  getClientById: (state) => (clientId: string) => {
    return state.clients.data.find((client: Client) => client.id === clientId);
  },
  getPlaceById: (state) => (placeId: string) => {
    return state.places.data.find((place: Place) => place.id === placeId);
  },

  getProjectbyId: (state) => (projectId: string) => {
    return state.projects.data.find(
      (project: Project) => project.id === projectId,
    );
  },
  getProjectData(state): Project[] {
    return state.projects.data;
  },
  getProjectLoading(state): boolean {
    return state.projects.loading;
  },
  getProjectError(state): string | null {
    return state.projects.error;
  },

  getClientsPlacesDataAsTable(state): ClientsPlaces[] {
    return [...state.clientsPlaces.data]
      .map((client: any) => {
        return [...client.children]
          .map((site: any) => {
            return [...site.children].map((project: any, index: number) => {
              return {
                projectId: project.id,
                projectName: project.name,
                siteId: site.id,
                siteName: site.name,
                clientId: client.id,
                clientName: client.name,
                numProjectPerSite: index === 0 ? [...site.children].length : 0,
              };
            });
          })
          .flat();
      })
      .map((projectArray: any) => {
        return [...projectArray].map((project: any, index: number) => {
          return {
            ...project,
            numProjectPerClient: index === 0 ? [...projectArray].length : 0,
          };
        });
      })
      .flat();
  },
  getClientsPlacesData(state): ClientsPlaces[] {
    return state.clientsPlaces.data;
  },
  getClientsPlacesLoading(state): boolean {
    return state.clientsPlaces.loading;
  },
  getClientsPlacesError(state): string | null {
    return state.clientsPlaces.error;
  },
  // AGGREGATIONS
  getAggregationsData(state): Aggregations[] {
    return state.aggregations.data;
  },
  getAggregationsLoading(state): boolean {
    return state.aggregations.loading;
  },
  getAggregationsError(state): string | null {
    return state.aggregations.error;
  },

  //UNITS
  getUnits(state): Unit[] {
    return state.units.data;
  },
  getUnitsLoading(state): boolean {
    return state.units.loading;
  },
  getUnitsError(state): string | null {
    return state.units.error;
  },
};
